const validations = [
    {
        field: 'name',
        method: 'isEmpty',
        validWhen: false,
        message: 'Name is a required field.'
    },
    {
        field: 'description',
        method: 'isEmpty',
        validWhen: false,
        message: 'Description is a required field.'
    },
    {
        field: 'categoryId',
        method: 'isEmpty',
        validWhen: false,
        message: 'Plan Type is a required field.'
    },
    {
        field: 'SelectedSubCategories',
        method: 'isEmpty',
        validWhen: false,
        message: 'Plan Category is a required field.'
    },
    {
        field: 'startDate',
        method: 'isEmpty',
        validWhen: false,
        message: 'Start Date is a required field.'
    },
    {
        field: 'startDate',
        allowBlank: true,
        method: 'isISO8601',
        validWhen: true,
        message: 'Start Date has to be a valid date.'  
    },
    {
        field: 'endDate',
        allowBlank: true,
        method: 'isISO8601',
        validWhen: true,
        message: 'End Date has to be a valid date.'  
    }
];

export default validations;
